


















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import DateTimeMixin from "@/components/mixin/date-time-mixin";

 class  PageLockingLineRequest extends PageRequest{
        locationType:string;
        lockingId:number;
  }
  class LocationLockingInfo
  {
    id:number;
    name:string;
    locationType:string;
    locationTypeName:string;
    lockTime:Date;
    unLockTime:Date;
    creatorUserName:string;
    creationTime :Date;
    
  }
 @Component
export default class ViewLocking extends mixins(ListMixin, DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  id: number=0;
  spinShow:boolean = false;
  namespace = 'locationLockingLine';
  pagerequest:PageLockingLineRequest=new PageLockingLineRequest();
  locking:LocationLockingInfo= new LocationLockingInfo();
  get store () {
    return this.$store.state.locationLockingLine;
  }
  get isBin()
  {
      return !Util.isNull(this.locking.locationType) && this.locking.locationType== AppConsts.locationType.bin;
  }
  canUnLock()
  {
    return this.hasPermission('Operations.LocationLocking.UnLock') && Util.isNull(this.locking.unLockTime);
  }
  onGoBack(){
     this.$root.$router.push({name: 'location-locking'});
  }
  
  unLock() {
    var confirmContent = this.L('Confirm.UnLockLocationLocking');
    this.$Modal.confirm({
          title:this.L('Tips'),
          content:confirmContent,
          okText:this.L('Yes'),
          cancelText:this.L('No'),
          onOk:async()=>{
            this.spinShow= true;
            try {
               await this.$store.dispatch({
                        type: "locationLocking/unlock",
                        data: {Id:this.locking.id}
                      }).then(re=>{
                      this.refreshPage();
                      this.spinShow= false;
                      });
            } catch (error) {
                      this.spinShow= false;
            }
          }
    });
  }
  async created(){
        this.spinShow = true;
        try {
          this.id = +this.$root.$router.currentRoute.params.id;
          await this.refreshPage();
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
  }
  async refreshPage()
  {
     await this.$store
        .dispatch({
          type: "locationLocking/get",
          data: { id: this.id }
        })
        .then(result => {
          this.locking = result;
           this.getpage();
        });
  }
  preGetPage()
  {
    this.pagerequest.locationType = this.locking.locationType;
    this.pagerequest.lockingId = this.locking.id;
  }
 
  get columns(){

    return [
        {
            title:Util.L('Code'),
            width: 200,
            key:'locationCode'
        },
        {
            title:Util.L('Type'),
            width: 150,
            key:'locationTypeName'
        },this.isBin?
        {
            title:Util.L('AllocatedQty'),
              key:'allocatedQty',
              align:"right",
              render:(h:any,params:any)=>{
                  if(Util.isNull(params.row.allocatedQty))
                  return '0';
                  return h("span", Util.toViewNumberString(params.row.allocatedQty));
              }
        }
        :
        {
            title:Util.L('Status'),
            key:'statusName'
        }
    ];
  }
}
